import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconUserExisting = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 23 17"
      width={20}
      height={20}
      className="block w-full h-full fill-current"
    >
      <path d="M10.367 3.4a3.4 3.4 0 116.8 0v2.267a3.4 3.4 0 01-6.8 0V3.4zm3.4 7.933a18.053 18.053 0 019.066 2.426V17H4.7v-3.241a18.067 18.067 0 019.067-2.426zM8.698 1.806L2.964 6.903.096 4.037l1.272-1.274L3.036 4.43 7.502.46l1.196 1.346z" />
    </svg>,
  );
IconUserExisting.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconUserExisting;
